import React from 'react';

export default function ProfileOfficialSection({ official = {} }) {
  return (
    <div className="rounded-2xl border border-outline-variant/25 bg-surface-container-lowest shadow-xs overflow-hidden">
      {/* Header bar matching Screenshot 1 */}
      <div className="bg-primary/95 px-6 py-4 flex items-center justify-between text-white">
        <div className="flex items-center gap-2.5">
          <span className="material-symbols-outlined text-xl">badge</span>
          <h2 className="text-base font-bold tracking-wide">Official Information</h2>
        </div>
        <span className="text-xs font-semibold bg-white/15 px-3 py-1 rounded-lg">
          Company Policy & Allocation
        </span>
      </div>

      <div className="p-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          {/* Official Info Data Grid (Left / Center) */}
          <div className="lg:col-span-8 grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-4">
            <div className="flex justify-between items-center py-2 border-b border-outline-variant/15">
              <span className="text-xs font-bold text-slate-500">Probation Period (in Months)</span>
              <span className="text-xs font-sans tabular-nums font-bold text-on-surface">
                {official.probationPeriod || '6 Months'}
              </span>
            </div>

            <div className="flex justify-between items-center py-2 border-b border-outline-variant/15">
              <span className="text-xs font-bold text-slate-500">Confirmation Date</span>
              <span className="text-xs font-sans tabular-nums font-bold text-on-surface">
                {official.confirmationDateDisplay || '14/08/2022'}
              </span>
            </div>

            <div className="flex justify-between items-center py-2 border-b border-outline-variant/15">
              <span className="text-xs font-bold text-slate-500">Notice Period (In Days)</span>
              <span className="text-xs font-sans tabular-nums font-bold text-on-surface">
                {official.noticePeriod || '60 Days'}
              </span>
            </div>

            <div className="flex justify-between items-center py-2 border-b border-outline-variant/15">
              <span className="text-xs font-bold text-slate-500">ID Card No</span>
              <span className="text-xs font-mono font-bold text-on-surface">
                {official.idCardNo || '1144'}
              </span>
            </div>

            <div className="flex justify-between items-center py-2 border-b border-outline-variant/15">
              <span className="text-xs font-bold text-slate-500">Assigned Shift</span>
              <span className="text-xs font-bold text-primary">
                {official.shift || 'New Gen 11AM - 6 PM'}
              </span>
            </div>

            <div className="flex justify-between items-center py-2 border-b border-outline-variant/15">
              <span className="text-xs font-bold text-slate-500">Leave Rule</span>
              <span className="text-xs font-bold text-on-surface">
                {official.leaveRule || 'Standard'}
              </span>
            </div>

            <div className="flex justify-between items-center py-2 border-b border-outline-variant/15">
              <span className="text-xs font-bold text-slate-500">Attendance Rule</span>
              <span className="text-xs font-bold text-on-surface">
                {official.attendanceRule || 'Gen'}
              </span>
            </div>

            <div className="flex justify-between items-center py-2 border-b border-outline-variant/15">
              <span className="text-xs font-bold text-slate-500">Reporting Manager</span>
              <span className="text-xs font-bold text-slate-800">
                {official.manager || 'Shwet Nigam # Staff'}
              </span>
            </div>

            <div className="flex justify-between items-center py-2 border-b border-outline-variant/15 sm:col-span-2">
              <span className="text-xs font-bold text-slate-500">Daily Minimum Swipes</span>
              <span className="text-xs font-sans tabular-nums font-bold text-emerald-600">
                {official.swipes || '2'} Swipes (IN / OUT)
              </span>
            </div>
          </div>

          {/* Tips / Guidelines Panel (Right) matching Screenshot 1 */}
          <div className="lg:col-span-4 rounded-2xl bg-amber-500/10 border border-amber-500/20 p-5">
            <div className="flex items-center gap-2 text-amber-800 font-bold text-xs uppercase tracking-wider mb-2.5">
              <span className="material-symbols-outlined text-base">lightbulb</span>
              <span>Official Tips</span>
            </div>
            <ul className="space-y-2 text-xs text-amber-900 font-medium">
              <li className="flex items-start gap-1.5">
                <span className="text-amber-600 font-bold">•</span>
                <span>Use this screen to update personal and official details.</span>
              </li>
              <li className="flex items-start gap-1.5">
                <span className="text-amber-600 font-bold">•</span>
                <span>Official fields (shift, manager, leave rules) are managed by HR.</span>
              </li>
              <li className="flex items-start gap-1.5">
                <span className="text-amber-600 font-bold">•</span>
                <span>Reach out to HR admin for any official policy adjustments.</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
